import React, { useState, useEffect } from "react";
import axios from "../api/axios"; 
import { useNavigate, Link } from "react-router-dom";

export default function EditProfile() {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("/user", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser({
          id: res.data.id,
          name: res.data.name,
          email: res.data.email,
          oldPassword: "",
          password: "",
          confirmPassword: "",
        });
      } catch (err) {
        console.error("Failed to fetch profile", err);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ If user wants to change password, require old password
    if (user.password) {
      if (!user.oldPassword) {
        setMessage("Old password is required to change your password!");
        return;
      }
      if (user.password !== user.confirmPassword) {
        setMessage("New passwords do not match!");
        return;
      }
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const payload = {
        name: user.name,
        email: user.email,
      };

      if (user.password) {
        payload.old_password = user.oldPassword;
        payload.password = user.password;
      }

      await axios.put(`/users/${user.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMessage("Profile updated successfully!");
      setLoading(false);
      navigate("/profile");
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Update failed. Please try again."
      );
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "500px" }}>
      <h2 className="mb-4">
        Edit Profile <Link to="/profile" className="btn btn-outline-warning">Back</Link>
      </h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={user.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={user.email}
            onChange={handleChange}
            required
          />
        </div>

        <hr />
        <h6>Change Password (Optional)</h6>

        <div className="mb-3">
          <label className="form-label">Old Password</label>
          <input
            type="password"
            name="oldPassword"
            className="form-control"
            value={user.oldPassword}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            value={user.password}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Confirm New Password</label>
          <input
            type="password"
            name="confirmPassword"
            className="form-control"
            value={user.confirmPassword}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary w-100" disabled={loading}>
          {loading ? "Updating..." : "Update Profile"}
        </button>
      </form>
    </div>
  );
}
